import { render, staticRenderFns } from "./TheSnapshotSubmitQuery.vue?vue&type=template&id=9fcb25de&"
import script from "./TheSnapshotSubmitQuery.vue?vue&type=script&lang=js&"
export * from "./TheSnapshotSubmitQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports